<template>
  <div class="c-verify">
    <h1 class="c-users-information__title">{{ $t('usersInformation.verify.title') }}</h1>
    <div v-if="!mfaDetails.MultiFactorAuthEnabled">
      <p class="c-users-information__text">{{ $t('usersInformation.verify.text1') }}</p>
      <div v-if="mfaDetails" class="login--tabs verify--tabs">
        <input type="radio" name="qr-code" id="tab1" checked />
        <input type="radio" name="qr-code" id="tab2" />
        <ul class="login--tabs__nav verify--tabs__nav">
          <li class="login--tabs__nav-tab">
            <label for="tab1">
              <p4a-icon :icon="'qr'" /> QR
            </label>
          </li>
          <li class="login--tabs__nav-tab">
            <label for="tab2">
              <p4a-icon :icon="'embed'" /> Code
            </label>
          </li>
        </ul>
        <div class="login--tabs__content">
            <span class="login-form__QR"><img :src="mfaDetails.QrImage"></span>
        </div>
        <div class="login--tabs__content verify--tabs__content">
          <p class="login-form__text--code">
            <code>{{mfaDetails.MfaSecret}}</code>
          </p>
        </div>
      </div>
      <p class="c-users-information__text">{{ $t('usersInformation.verify.text2') }}</p>
      <div class="form-row" @keyup.enter="sendMfaCode">
        <p4a-input
          v-model="mfaInput"
          :warning="{visible: mfaValidated, showIcon: true, message: ''}"
          :type="'text'"
          :size="'small'"
          :leftIcon="''"
          :autofocus="true"
          @keyup.native="hideWarning"
        />
        <p4a-button
          @click="sendMfaCode"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="'ts'"
          :size="'small'"
          :fullWidth="false"
          :disable="false"
          :text="$t('usersInformation.verify.confirm')">
        </p4a-button>
      </div>
    </div>
    <div v-else>
      <p class="c-users-information__text">{{ $t('usersInformation.verify.disabledText') }}</p>
      <div class="form-row">
        <p4a-button
          @click="disableMfa"
          :showIcon="false"
          :onlyIconVisible="false"
          :product="'ts'"
          :size="'small'"
          :fullWidth="false"
          :disable="false"
          :text="$t('usersInformation.verify.disable')">
        </p4a-button>
      </div>
    </div>

  </div>
</template>

<script>
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'

export default {
  props: {
    mfaDetails: {
      type: Object
    }
  },
  data () {
    return {
      mfaInput: null,
      mfaValidated: false
    }
  },
  methods: {
    sendMfaCode () {
      let vm = this
      if (vm.mfaInput === null) {
        vm.mfaValidated = true
      } else {
        usersAndGroupsApi.verifyMfa({ Code: vm.mfaInput, MfaId: vm.mfaDetails.MfaId }).then(success => {
          if (success) {
            vm.mfaValidated = false
            this.$parent.$p4aToast.show(this.$i18n.t('general.successHeader'), this.$i18n.t('general.successfullyVerified'), 'success', 4000)
            this.mfaDetails.MultiFactorAuthEnabled = true
          } else {
            vm.mfaValidated = true
          }
        })
      }
    },
    disableMfa () {
      usersAndGroupsApi.disableMfa().then(done => {
        this.mfaDetails.MultiFactorAuthEnabled = false
      })
    },
    hideWarning () {
      // Hide warning while typing
      this.mfaValidated = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/verify.vue